<template>
    <div id="detail">
        <div class="header">
            <div class="title">{{ $t("ticimax.members") }}</div>
            <div class="subtitle">{{ $t("ticimax.segmentedMembersDesc") }}</div>
        </div>
        <div class="filters">
            <div class="members-search">
                <a-input-search v-model="filters.query" :placeholder="$t('ticimax.searchAMember')" />
            </div>
        </div>
        <div class="toolbox">
            <ve-pagination
                :total="totalMembers"
                :page-index="cursor.page"
                :page-size="cursor.perPage"
                :page-size-option="[10, 15, 20, 50, 100]"
                @on-page-number-change="(val) => (cursor.page = val)"
                @on-page-size-change="(val) => (cursor.perPage = val)"
            />
            <div class="page-actions">
                <SupsisButton primary @click="startSyncMembers">Sync Members</SupsisButton>
            </div>
        </div>
        <div class="members-content" style="display: flex; gap: 10px">
            <div class="left">
                <div v-for="(group, index) of filters.groups" :key="group.id">
                    <FilterGroup
                        :on-removed="onFilterGroupRemoved"
                        v-model="filters.groups[index]"
                        :show-remove-button="filters.groups.length > 1"
                    />
                    <div
                        class="filter-condition-wrapper"
                        v-if="filters.groups.length > 1 && index !== filters.groups.length - 1"
                    >
                        <div class="filter-condition">
                            <a-select
                                :value="filters.operator"
                                @change="(op) => (filters.operator = op)"
                                @click="
                                    (e) => {
                                        e.stopPropagation();
                                    }
                                "
                                @mouseenter="() => (selectHovered = true)"
                                @mouseleave="() => (selectHovered = false)"
                                :class="{ hovered: selectHovered }"
                            >
                                <a-select-option value="or">{{ $t("chatbotv2.or") }}</a-select-option>
                                <a-select-option value="and"> {{ $t("chatbotv2.and") }}</a-select-option>
                            </a-select>
                        </div>
                    </div>
                </div>
                <div class="filter-add-group-wrapper">
                    <div class="filter-add-group" @click="addFilterGroup">
                        <div class="filter-add-group-plus">
                            <span class="material-icons"> add </span>
                        </div>
                        <span>{{ $t("chatbotv2.addFilterGroup") }}</span>
                    </div>
                </div>
            </div>
            <ve-table
                :columns="getColumns()"
                :table-data="members"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :border-x="true"
                :border-y="true"
                row-key-field-name="_id"
                id="ticimax-members-table"
                :fixed-header="true"
                :sort-option="sortOption"
                style="word-break: break-word"
                :style="{
                    width: getMaxWidth() + 'px',
                }"
                :scroll-width="getMaxWidth() + 3500"
                :clipboard-option="clipboardOption"
            />
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import moment from "moment/moment";
import { TICIMAX_API } from "../../../../../api/ticimax";
import MoneyFormatter from "../../../../../components/MoneyFormatter.vue";
import log2 from "../../../../../utils/log2";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import FilterGroup from "./automation/filter/FilterGroup.vue";
import { generateRandomId } from "../../../../../utils/session";

const log = log2("TicimaxMembers");
export default {
    name: "TicimaxMembers",
    components: {
        FilterGroup,
        MoneyFormatter,
        SupsisButton,
    },
    props: {
        channel: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            selectHovered: false,
            renderKey: 0,
            filters: {
                operator: "or",
                groups: [],
            },
            totalMembers: 0,
            sort: {
                field: "lastOrderDate",
                direction: -1,
            },
            cursor: {
                page: 1,
                perPage: 50,
            },
            loadingInstance: null,
            rowStyleOption: {
                stripe: true,
            },
            sortOption: {
                sortChange: (params) => {
                    const sortVal = {
                        asc: 1,
                        desc: -1,
                    };
                    const sorting = Object.keys(params).filter((param) => !!params[param]);
                    this.sort = {
                        field: sorting[0],
                        direction: sortVal[params[sorting[0]]],
                    };
                },
            },
            clipboardOption: {
                copy: true,
                paste: false,
                cut: false,
                delete: false,
            },
            cellStyleOption: {
                bodyCellClass: function ({ row, column, rowIndex }) {
                    const classNames = [column.key];
                    if (column.key === "segment") {
                        classNames.push(row.segment);
                    } else if (column.key === "vip") {
                        if (row.vip) {
                            classNames.push("vip-active");
                        }
                    }
                    return classNames.join(" ");
                },
            },
            members: [],
            types: {},
            paymentTypes: {
                bkme: "BKM Express",
                compay: "Compay",
                gpay: "Garanti Pay",
                bt: "Havale",
                kapidannakitodeme: "Kapıdan Nakit Ödeme",
                kapidaodemekredikarti: "Kapıda Ödeme Kredi Kartı",
                cc: "Kredi Kartı",
                padcc: "Kredi Kartı Kapıda Ödeme",
                mexp: "Mobil Express",
                multinet: "Multinet",
                nakit: "Nakit",
                sodexo: "Sedexo",
            },
            filterTimeout: null,
        };
    },
    methods: {
        getMaxWidth() {
            return window.innerWidth - 710;
        },
        fetch() {
            log("fetch", { cursor: this.cursor, filters: this.filters, sort: this.sort });
            this.loading = true;
            this.loadingInstance.show();
            TICIMAX_API.listMembers(this.cursor, this.filters, this.sort)
                .then((res) => {
                    this.members = res.data.data;
                    this.totalMembers = res.data.total;
                    this.renderKey += 1;
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    this.loading = false;
                    this.loadingInstance.close();
                });
        },
        getColumns() {
            console.log("getColumns", this.users);
            return [
                // {
                //     field: "",
                //     key: "a",
                //     type: "expand",
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "email",
                    key: "email",
                    title: this.$t("chatbotv2.attr.email"),
                    align: "left",
                    fixed: "left",
                    width: 200,
                },
                {
                    field: "fullname",
                    key: "fullname",
                    title: this.$t("chatbotv2.attr.name"),
                    align: "left",
                    width: 150,
                },
                {
                    field: "phone",
                    key: "phone",
                    title: this.$t("chatbotv2.attr.phone"),
                    align: "left",
                    width: 150,
                },
                {
                    field: "province",
                    key: "province",
                    title: this.$t("chatbotv2.city"),
                    align: "left",
                    width: 100,
                },
                {
                    field: "county",
                    key: "county",
                    title: this.$t("ticimax.attributes.county"),
                    align: "left",
                    width: 100,
                },
                {
                    field: "totalOrderCount",
                    key: "totalOrderCount",
                    title: this.$t("ticimax.attributes.totalOrderCount"),
                    align: "left",
                    width: 100,
                    sortBy: this.getSortVal("totalOrderCount"),
                },
                {
                    field: "totalOrderAmount",
                    key: "totalOrderAmount",
                    title: this.$t("ticimax.attributes.totalOrderAmount"),
                    align: "left",
                    width: 150,
                    sortBy: this.getSortVal("totalOrderAmount"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(MoneyFormatter, {
                            props: {
                                price: row.totalOrderAmount,
                            },
                        });
                    },
                },
                {
                    field: "minOrderAmount",
                    key: "minOrderAmount",
                    title: this.$t("ticimax.attributes.minOrderAmount"),
                    align: "left",
                    width: 150,
                    sortBy: this.getSortVal("minOrderAmount"),

                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(MoneyFormatter, {
                            props: {
                                price: row.minOrderAmount,
                            },
                        });
                    },
                },
                {
                    field: "maxOrderAmount",
                    key: "maxOrderAmount",
                    title: this.$t("ticimax.attributes.maxOrderAmount"),
                    align: "left",
                    width: 150,
                    sortBy: this.getSortVal("maxOrderAmount"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(MoneyFormatter, {
                            props: {
                                price: row.maxOrderAmount,
                            },
                        });
                    },
                },
                {
                    field: "firstOrderDate",
                    key: "firstOrderDate",
                    title: this.$t("ticimax.attributes.firstOrderDate"),
                    align: "left",
                    width: 175,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{moment(row.firstOrderDate).format("YYYY-MM-DD HH:mm:ss")}</span>;
                    },
                    sortBy: this.getSortVal("firstOrderDate"),
                },
                {
                    field: "lastOrderDate",
                    key: "lastOrderDate",
                    title: this.$t("ticimax.attributes.lastOrderDate"),
                    align: "left",
                    width: 175,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{moment(row.lastOrderDate).format("YYYY-MM-DD HH:mm:ss")}</span>;
                    },
                    sortBy: this.getSortVal("lastOrderDate"),
                },
                {
                    field: "firstPaymentType",
                    key: "firstPaymentType",
                    title: this.$t("ticimax.attributes.firstPaymentType"),
                    width: 120,
                    align: "left",
                },
                {
                    field: "lastPaymentType",
                    key: "lastPaymentType",
                    title: this.$t("ticimax.attributes.lastPaymentType"),
                    width: 120,
                    align: "left",
                },
                {
                    field: "firstSource",
                    key: "firstSource",
                    title: this.$t("ticimax.attributes.firstSource"),
                    width: 100,
                    align: "left",
                },
                {
                    field: "lastSource",
                    key: "lastSource",
                    title: this.$t("ticimax.attributes.lastSource"),
                    width: 100,
                    align: "left",
                },
                {
                    field: "usedCouponCount",
                    key: "usedCouponCount",
                    title: this.$t("ticimax.attributes.usedCouponCount"),
                    align: "left",
                    width: 120,
                    sortBy: this.getSortVal("usedCouponCount"),
                },
                {
                    field: "usedCouponAmount",
                    key: "usedCouponAmount",
                    title: this.$t("ticimax.attributes.usedCouponAmount"),
                    align: "left",
                    width: 150,
                    sortBy: this.getSortVal("usedCouponAmount"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(MoneyFormatter, {
                            props: {
                                price: row.usedCouponAmount,
                            },
                        });
                    },
                },
                {
                    field: "couponUsingPercentage",
                    key: "couponUsingPercentage",
                    title: this.$t("ticimax.attributes.couponPercent"),
                    align: "left",
                    width: 100,
                    sortBy: this.getSortVal("couponUsingPercentage"),
                },
                {
                    field: "vip",
                    key: "vip",
                    title: "VIP",
                    align: "left",
                    width: 100,
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.vip ? <span>VIP</span> : <span>-</span>;
                    },
                },
                {
                    field: "isCouponUser",
                    key: "isCouponUser",
                    title: this.$t("ticimax.attributes.isCouponUser"),
                    align: "left",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.isCouponUser ? <span class="coupon">Kuponcu</span> : <span>-</span>;
                    },
                },
                {
                    field: "tookDayFromLastOrder",
                    key: "tookDayFromLastOrder",
                    title: this.$t("ticimax.attributes.tookDayFromLastOrder"),
                    width: 100,
                    align: "left",
                    sortBy: this.getSortVal("tookDayFromLastOrder"),
                },
                {
                    field: "segment",
                    key: "segment",
                    title: this.$t("ticimax.segment"),
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span class="coupon">{row.segment}</span>;
                    },
                    fixed: "right",
                    width: 100,
                },
            ];
        },
        getSortVal(field) {
            return this.sort.field === field ? (this.sort.direction === 1 ? "asc" : "desc") : "";
        },
        applyFilter(key, val) {
            this.filters = _.cloneDeep(this.filterClone);
        },
        startSyncMembers() {
            const dayCount = window.prompt("Please enter the day count to sync", 1);
            TICIMAX_API.startSyncMembers(dayCount).then((res) => {
                this.$message.success("Sync started");
                this.fetch();
            });
        },
        onFilterGroupRemoved(id) {
            this.filters.groups = this.filters.groups.filter((group) => group.id !== id);
        },
        addFilterGroup() {
            const id = generateRandomId();
            this.filters.groups.push({
                id,
                operator: "or",
                filters: [],
            });
        },
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector("#ticimax-members-table"),
            name: "wave",
        });
        TICIMAX_API.getTypes().then((res) => {
            const types = res.data;
            this.types = Object.keys(types).reduce((acc, type) => {
                if (type === "paymentTypes") {
                    acc[type] = types[type].map((key) => ({ key, label: this.paymentTypes[key.toLowerCase()] || key }));
                } else {
                    acc[type] = types[type].map((key) => ({ key, label: key }));
                }
                return acc;
            }, {});
        });
        this.fetch();
    },
    watch: {
        filters: {
            handler: _.debounce(function (val) {
                log("filters changed=>", val);
                this.cursor.page = 1;
                this.fetch();
            }, 400),
            deep: true,
        },
        sort: {
            handler: function (val) {
                this.fetch();
            },
            deep: true,
        },
        cursor: {
            handler: function (val) {
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
#ticimax-members-table {
    .ve-table-body-td {
        &.segment {
            padding: 0px;
            font-weight: 700;
            font-size: 14px;
            text-transform: uppercase;

            span {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &.active-30 {
                background-color: #67c23a;

                color: white;
            }

            &.active-60 {
                background-color: #e6a23c;
                color: white;
            }

            &.active-90 {
                background-color: #f56c6c;
                color: white;
            }

            &.lost {
                background-color: #909399;
                color: white;
            }
        }

        &.vip {
            padding: 0px;

            font-weight: 700;
            font-size: 14px;
            text-transform: uppercase;

            span {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &.vip-active {
                background-image: linear-gradient(
                    to right,
                    #d16ba5,
                    #c777b9,
                    #ba83ca,
                    #aa8fd8,
                    #9a9ae1,
                    #8aa7ec,
                    #79b3f4,
                    #69bff8,
                    #52cffe,
                    #41dfff,
                    #46eefa,
                    #5ffbf1
                );
                color: white;
            }
        }
    }
}
</style>
<style scoped lang="scss">
.header {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;

    border-bottom: 1px solid var(--color-border-default);

    .title {
        font-size: 18px;
        font-weight: 700;
        color: var(--color-text-strong-default);
        padding-left: 5px;
    }

    .subtitle {
        font-size: 14px;
        color: var(--color-text-strong-default);
    }
}

.filters {
    margin: 10px 0px;

    .members-search {
        margin: 5px 0px;
    }
}
.toolbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.members-content {
    margin-top: 10px;
    .filter-condition-wrapper {
        align-items: center;
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 30px;

        &:before {
            border-top: 1px solid #ccc;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        &:after {
            border-top: 1px solid #ccc;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        .filter-condition {
            margin: 0px 25px;
            width: 80px;

            .ant-select {
                &.hovered {
                    .ant-select-selection {
                        border-color: #40a9ff !important;
                        border-right-width: 1px !important;
                        background: #40a9ff52 !important;
                    }
                }
            }
        }
    }

    .filter-add-group-wrapper {
        align-items: center;
        display: flex;
        height: 40px;
        justify-content: center;
        width: 100%;

        &:before {
            border-top: 1px solid #ccc;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        &:after {
            border-top: 1px solid #ccc;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        .filter-add-group {
            cursor: pointer;
            display: flex;
            margin: 0 10px;
            transition: opacity 0.3s;

            span {
                color: #475e7a;
                font-weight: 600;
            }

            .filter-add-group-plus {
                align-items: center;
                background: #fff;
                border-radius: 100%;
                box-shadow: 0 1px 4px 0 rgb(0 0 0 / 19%);
                display: flex;
                height: 22px;
                justify-content: center;
                margin-right: 10px;
                transition: background-color 0.3s;
                width: 22px;

                &:hover {
                    background: #006cff;
                    color: #fff;

                    .material-icons {
                        color: #fff;
                    }
                }

                .material-icons {
                    color: #006cff;
                    font-size: 12px;
                    margin-left: 1px;
                    transition: color 0.6s;
                }
            }
        }
    }
    .left {
        width: 300px;
        margin-right: 10px;
    }
}
</style>
